import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchDataTrace = async ({ uri, token, expire }: any) => {
  const result = await fetch(`${REACT_APP_VMS_BASE_URL}/${uri}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  const response = await result.json();
  if (response.statusCode === 401) {
    expire();
  }
  return response;
};

export default fetchDataTrace;
